<template>
	<div v-if="!hide" class="landing-image" :style="customStyles">
		<div v-if="overlayText" class="landing-image__overlay">
			<h1 v-if="overlayText.title" class="landing-image__title" data-typo-type="title">
				{{ overlayText.title }}
			</h1>

			<h2
				v-if="overlayText.subtitle"
				v-html="overlayText.subtitle"
				class="landing-image__subtitle"
				data-typo-type="subtitle"
			></h2>
		</div>

		<img :src="img" alt="" />
	</div>
</template>

<script>
export default {
	name: 'LandingImage',

	props: {
		hide: {
			type: Boolean,
			default: false,
		},

		img: {
			type: [String, null],
			default: null,
		},

		overlayText: {
			type: Object,
			default: null,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-image {
	position: relative;
	max-width: 100%;
	text-align: center;
	margin: var(--size-16) auto;
	box-sizing: content-box;

	img {
		max-height: 100%;
	}

	&__overlay {
		position: absolute;
		text-align: center;

		left: var(--size-16);
		right: var(--size-16);
		top: 10%;

		padding: 0 var(--size-10);
	}

	&__title {
		font-size: var(--size-24);
		line-height: var(--size-28);
		font-weight: 700;
		text-transform: uppercase;
	}

	&__subtitle {
		font-size: var(--size-14);
		line-height: var(--size-20);
		font-weight: 400;
		text-transform: uppercase;
	}
}
</style>
